import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { formatDate } from '../../utils/date';

export type SimpleTableHeaderProp<T> = Array<{
  key: keyof T;
  label: string;
  date?: boolean;
}>;

type Props<T> = {
  items: Array<T>;
  header: SimpleTableHeaderProp<T>;
};

const SimpleTable = <T extends object>(props: Props<T>) => {
  const { items, header } = props;

  return (
    <Table>
      <TableHead>
        <TableRow>
          {header.map((head, idx: number) => (
            <TableCell
              key={String(head.key)}
              align={idx !== 0 ? 'right' : undefined}
            >
              {head.label}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {items.map((item, idx) => (
          // eslint-disable-next-line react/no-array-index-key
          <TableRow key={idx}>
            {/* eslint-disable-next-line no-shadow */}
            {header.map(({ key, date }, idx) => (
              // eslint-disable-next-line react/no-array-index-key
              <TableCell key={idx} align={idx !== 0 ? 'right' : undefined}>
                {date ? formatDate(String(item[key])) : item[key]}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default SimpleTable;
